import { Route, Routes } from "react-router-dom";
import SignUp from "./Signup";
import Login from "./Login";
import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "./Dashboard";
import { getUser, refreshToken } from "./service";
import { useEffect, useState } from "react";
import { UserContext } from "./UserContext";
import ForgotPassword from "./ForgotPassword";
import ResendConfirmation from "./ResendConfirmation";
import ResetPassword from "./ResetPassword";

const App = () => {
  useEffect(() => {
    const refresh = async () => {
      try {
        await refreshToken();
      } catch (ex) {
        localStorage.clear();
        window.location = "/login";
      }
    };
    refresh();
  }, []);
  const [user, setUser] = useState(getUser);
  return (
    <UserContext.Provider value={{ user, setUser }}>
      <Routes>
        <Route path="resend-confirmation" element={<ResendConfirmation />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </UserContext.Provider>
  );
};

export default App;
